import { useQuery } from 'react-apollo'
import { ListConfigs } from '../../../graphql/configs/queries'
import { ConfigsFilter, ConfigsPage, ConfigsSort } from '@labsavvyapp/components'

interface ListConfigsVariables {
  limit?: number
  page?: number
  filter: ConfigsFilter
  sort?: ConfigsSort
}

export const useQueryListConfigsApi = (variables: ListConfigsVariables) => {
  const { filter, limit, sort, page } = variables

  const {
    data: configsListData,
    error: configsListError,
    loading: configsListLoading,
    refetch: refetchConfigsListData,
  } = useQuery(ListConfigs, {
    variables: {
      limit: limit || 20,
      sort: sort,
      filter: filter,
      page: page,
    },
  })

  return {
    data: configsListData?.listConfigs as ConfigsPage,
    error: configsListError,
    loading: configsListLoading,
    refetch: refetchConfigsListData,
  }
}
